export const REFRESH_STARTED = 'REFRESH_STARTED';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_FAILED = 'REFRESH_FAILED';